/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainStoreStoreProductLabels, FxIdDomainStoreStoreProductLabelsFromJSONTyped, FxIdDomainStoreStoreProductLabelsToJSON, } from './FxIdDomainStoreStoreProductLabels';
export function FxIdApplicationStoreProductDataLabelsFromJSON(json) {
    return FxIdApplicationStoreProductDataLabelsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreProductDataLabelsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainStoreStoreProductLabels(json)) {
        return FxIdDomainStoreStoreProductLabelsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreProductDataLabelsToJSON(json) {
    return FxIdApplicationStoreProductDataLabelsToJSONTyped(json, false);
}
export function FxIdApplicationStoreProductDataLabelsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainStoreStoreProductLabels(value)) {
        return FxIdDomainStoreStoreProductLabelsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreProductDataLabels.js.map